import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import CreateEditAnnouncementsModal from '@@/core/pages/Announcements/CreateEditAnnouncementsModal/CreateEditAnnouncementsModal'
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
  name: "Announcements",
  components: {
    FormModal,
    Loading,CreateEditAnnouncementsModal,
    BTooltip, BButton, BCard, BTable, BCollapse, BFormGroup, BFormInput
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      createRules:[],
      editRules:[],
      announcement: [],
      mode: 'create',
      url: 'admin/announcements',
      fields: [{
        key: 'index',
        label: 'ردیف'
      },
        {
          key: 'title',
          label: 'عنوان پیام'
        },
        {
          key: 'read_at',
          label: 'تاریخ خوانده شده'
        },
        {
          key: 'created_at',
          label: 'تاریخ ثبت'
        },
        // {
        //   key: 'مشاهده',
        //   label: 'انبار ها'
        // },
        {
          key: 'edit',
          label: 'ویرایش'
        },
        {
          key: 'delete',
          label: 'حذف'
        },
      ],
      filter: {

      },
    }
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    handleDataSubmitted(data) {
      this.items = data;
    }, 
    createModal() {
      this.announcement = {
        selectedCustomer: null,
        title: '',
        description: ''
      }
      this.mode = 'create'
      this.$root.$emit('bv::show::modal', 'create-edit-announcements-modal')
    },
    editModal(item) {
      this.announcement = {
        selectedCustomer: item.customer,
        id: item.id,
        title: item.title,
        description: item.description
      }
      this.mode = 'edit'
      this.$root.$emit('bv::show::modal', 'create-edit-announcements-modal')
    },
  }
}
